module.exports = __webpack_public_path__ + "static/veges@2x-3a214e06e1b90bc556793741ffda305e.png";